export default "__VITE_ASSET__DvzRwDeE__$_?url__"